import {Injectable} from '@angular/core';
import {ChargedActModel} from '../../api/entity/chargedAct.model';
import {ChargedActRepository} from './ngrx/chargedAct.repository';
import {ChargedActDataServiceAdapter} from './ngrx/chargedActDataService.adapter';
import {AbstractFindOneByIdService} from '../../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class ChargedActFindOneByIdService extends AbstractFindOneByIdService<ChargedActModel, ChargedActModel> {

    constructor(repository: ChargedActRepository, dataServiceAdapter: ChargedActDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
